// extracted by mini-css-extract-plugin
export default {"menu":"style_menu__iCChL"};